const pl = {
  datePicker: {
    required: "Wpisz datę.",
    format: "Wpisz datę w formacie {{variable}}.",
    minimum: "Wpisz datę nie wcześniejszą niż {{variable}}.",
    maximum: "Wpisz datę nie późniejszą niż {{variable}}.",
  },
  dateRange: {
    incomplete: "Wpisz obie daty zakresu.",
    reversed: "Data końcowa nie może być wcześniejsza niż początkowa.",
    maximumDays: "Wybierz daty oddalone o nie więcej niż {{variable}} dni.",
  },
  timePicker: {
    placeholder: "gg:mm",
    enter: "Enter: {{variable}}",
    enterInvalid: "błędna godzina",
    required: "Wpisz godzinę.",
    format: "Wpisz godzinę, np. 8:50",
    minimum: "Wpisz godzinę nie wcześniejszą niż {{variable}}.",
    maximum: "Wpisz godzinę nie późniejszą niż {{variable}}.",
    unavailable: "Ta godzina nie istnieje w wybranym dniu.",
  },
  colorPicker: {
    hex: "HEX",
    recommended: "Polecane kolory",
    placeholder: "Wybierz kolor",
    select: "Wybierz kolor {{variable}}",
  },
  relativeDay: {
    today: "Dziś",
    tomorrow: "Jutro",
  },
  relativeTime: {
    now: "Przed chwilą",
    minutes_one: "{{count}} min temu",
    minutes_few: "{{count}} min temu",
    minutes_many: "{{count}} min temu",
    minutes_other: "{{count}} min temu",
    hours_one: "{{count}} godz. temu",
    hours_few: "{{count}} godz. temu",
    hours_many: "{{count}} godz. temu",
    hours_other: "{{count}} godz. temu",
    days_one: "{{count}} dzień temu",
    days_few: "{{count}} dni temu",
    days_many: "{{count}} dni temu",
    days_other: "{{count}} dnia temu",
  },
  colorPalette: {
    names: {
      blue: "Niebieski",
      amber: "Bursztynowy",
      green: "Zielony",
      pink: "Różowy",
      graphite: "Grafitowy",
      red: "Czerwony",
      lightGreen: "Jasnozielony",
      lightBlue: "Jasnoniebieski",
      indigo: "Indygo",
      lavender: "Lawendowy",
      rose: "Różany",
      orange: "Pomarańczowy",
      mustard: "Musztardowy",
      turquoise: "Turkusowy",
      sky: "Błękitny",
      mint: "Miętowy",
    },
  },
  emojiPicker: {
    open: "Wybierz emoji",
  },
  devicePreview: {
    desktop: "Komputer",
    tablet: "Tablet",
    phone: "Telefon",
  },
  placeholder: {
    desktopOnlyTitle: "Otwórz na większym ekranie",
    desktopOnlyDescription:
      "Ten widok potrzebuje więcej miejsca, niż daje telefon.\nOtwórz go na tablecie lub komputerze.",
  },
  common: {
    dialog: "Okno dialogowe",
    close: "Zamknij",
    rangeMinimum: "{{variable}} minimum",
    rangeMaximum: "{{variable}} maksimum",
    selectItem: "Zaznacz {{variable}}",
    cancel: "Anuluj",
    confirm: "Potwierdź",
    edit: "Edytuj",
    save: "Zapisz",
    apply: "Zastosuj",
    continue: "Kontynuuj",
    selected: "zaznaczono",
    searchPlaceholder: "Szukaj...",
    fileUploadPlaceholder: "Wybierz plik lub przeciągnij tutaj",
    fileUploadAction: "Wybierz plik",
    fileSizeOf: "z",
    fileUploading: "Pobieranie...",
    fileUploadRetry: "Spróbuj ponownie",
    remove: "Usuń",
    range: "Zakres",
    feature: "Funkcja",
    periodRange: "Zakres dat",
    more: "Więcej",
    actions: "Akcje",
    tags: "Tagi",
    filters: "Filtry",
    energy: "Energetyczność",
    protein: "Białko",
    fats: "Tłuszcze",
    carbs: "Węglowodany",
    micronutrients: "Mikroskładniki",
    macronutrients: "Makroskładniki",
    show: "Pokaż",
    clearAll: "Wyczyść wszystkie",
    createOption: "Dodaj „{{name}}”",

    noResultLabel: "Brak wyników",
    noResultDescription: "Spróbuj dostosować filtry lub kryteria wyszukiwania",
    clearFilters: "Wyczyść filtry",
    selectedCount: "Zaznaczono: {{count}}",
    unselect: "Odznacz",
    noDataYetTitle: "Brak danych",
    noDataYetDescription: "Nic tu jeszcze nie ma.",
    errorPlaceholderTitle: "Coś poszło nie tak",
    errorPlaceholderDescription: "Wystąpił błąd. Spróbuj ponownie później.",
    noDataAvailable: "Brak danych",
    noDataAvailablePlaceholder: "Brak danych do wyświetlenia",
    noFutureDataTitle: "Brak przyszłych danych",
    noFutureDataDescription:
      "Przyszłe dane pojawią się tutaj, gdy będą dostępne",
    noAccessDataTitle: "Ograniczony dostęp",
    noAccessDataDescription:
      "Nie masz dostępu do tych danych dla wybranego okresu",
    changeDateRange: "Zmień zakres dat",
    changeProperties: "Zmień właściwości",
    futureDescription: "Ta funkcja będzie dostępna w przyszłości",
    futureAccountDescription:
      "Ta funkcja wkrótce będzie dostępna dla Twojego konta",
    ownPropertyDescription: "To jest Twoja własna właściwość",

    accessLimited: "Ograniczony dostęp",
    accessLimitedForSomeDates: "Ograniczony dostęp dla niektórych dat",
    accessLimitedTooltipDescription:
      "Nie masz dostępu do danych dla niektórych dat w tym zakresie",
    accessLimitedAvailablePeriods: "Dostępne okresy:",

    pageOf: "Strona {{current}} z {{total}}",
    rowsPerPage: "Liczba wierszy:",
    pageOfEmphasis: "Strona <strong>{{current}}</strong> z {{total}}",
    firstPage: "Pierwsza strona",
    previousPage: "Poprzednia strona",
    nextPage: "Następna strona",
    lastPage: "Ostatnia strona",
  },
  calendar: {
    noEntries: "Brak wpisów w tym okresie",
    releaseToAdd: "{{duration}}, puść, żeby dodać",
    moreEntries: "+{{count}} więcej",
    noDayEntries: "Brak wpisów",
    dayEntries: "Wpisy tego dnia: {{count}}",
    noEntriesHint:
      "Kliknij w siatkę w widoku dnia albo tygodnia, żeby dodać wpis.",
    openDay: "Otwórz widok dnia",
    weekdayAbbr: {
      monday: "Pon",
      tuesday: "Wt",
      wednesday: "Śr",
      thursday: "Czw",
      friday: "Pt",
      saturday: "Sob",
      sunday: "Nd",
    },
    unassigned: "Pozostałe wpisy",
    previous: "Poprzedni",
    next: "Następny",
    previousMonth: "Poprzedni miesiąc",
    nextMonth: "Następny miesiąc",
    previousYear: "Poprzedni rok",
    nextYear: "Następny rok",
    navigation: {
      today: "Dziś",
      previousPeriod: "Poprzedni okres",
      nextPeriod: "Następny okres",
    },
    shortcuts: {
      today: "T",
      day: "D",
      week: "W",
      month: "M",
      list: "L",
    },
    months: {
      january: "Styczeń",
      february: "Luty",
      march: "Marzec",
      april: "Kwiecień",
      may: "Maj",
      june: "Czerwiec",
      july: "Lipiec",
      august: "Sierpień",
      september: "Wrzesień",
      october: "Październik",
      november: "Listopad",
      december: "Grudzień",
    },
    weekDaysMin: {
      monday: "Pn",
      tuesday: "Wt",
      wednesday: "Śr",
      thursday: "Cz",
      friday: "Pt",
      saturday: "Sb",
      sunday: "Nd",
    },
    periods: {
      thisMonth: "Ten miesiąc",
      monthToDate: "Od początku miesiąca",
      yearToDate: "Od początku roku",
      lastMonth: "Ostatni miesiąc",
      lastYear: "Ostatni rok",
      monthToEnd: "Do końca miesiąca",
      yearToEnd: "Do końca roku",
      thisYear: "Ten rok",
      nextMonth: "Następny miesiąc",
      next365Days: "Następne 365 dni",
    },
  },
  sidebar: {
    expandTooltip: "Rozwiń panel",
    collapseTooltip: "Zwiń panel",
    navigation: "Nawigacja główna",
    openNavigation: "Otwórz nawigację",
    closeNavigation: "Zamknij nawigację",
    search: "Szukaj",
    searchPlaceholder: "Szukaj…",
    soon: "Wkrótce",
    unseen: "Nowe",
  },
  pageSaveBar: {
    unsaved: "Masz niezapisane zmiany",
  },
  listPage: {
    search: "Szukaj",
    searchIn: "Szukaj w: {{variable}}",
    closeSearch: "Zamknij wyszukiwanie",
    more: "Więcej",
    filters: "Filtry",
    columns: "Kolumny",
    view: "Widok",
    list: "Lista",
    grid: "Siatka",
    showResults: "Pokaż wyniki",
    showResultsCount: "Pokaż wyniki ({{variable}})",
    resetFilters: "Wyczyść wszystkie",
    searchFilters: "Szukaj w filtrach",
    filterName: "Szukaj w filtrach",
    clearSection: "Wyczyść „{{variable}}”",
    clear: "Wyczyść",
    searchOptions: "Szukaj",
    noMatchingOptions: "Brak pasujących opcji",
    showAll: "Pokaż wszystkie ({{variable}})",
    showLess: "Pokaż mniej",
    noMatchingFilters: "Brak pasujących filtrów",
    noMatchingFiltersHint: "Sprawdź pisownię albo wyczyść szukanie.",
    moreFilters: "Więcej filtrów ({{variable}})",
    activeFilters: "Aktywne filtry:",
    clearAll: "Wyczyść wszystkie",
    removeFilter: "Usuń filtr „{{variable}}”",
  },
  spotlight: {
    title: "Wyszukiwanie",
    placeholder: "Szukaj…",
    recent: "Niedawno szukane",
    clear: "Wyczyść",
    results: "Wyniki wyszukiwania ({{count}})",
    noResults: "Brak wyników",
    remove: "Usuń „{{name}}” z historii",
  },
  theme: {
    switchToDark: "Przełącz na tryb ciemny",
    switchToLight: "Przełącz na tryb jasny",
  },
  richTextEditor: {
    unreadable:
      "Nie udało się odczytać zapisanej treści. Edycja jest zablokowana, żeby nie nadpisać oryginału — zgłoś to do nas.",
    toolbar: "Formatowanie",
    zoomIn: "Powiększ",
    zoomOut: "Pomniejsz",
    pageGuides: "Strony PDF",
    paragraph: "Tekst zwykły",
    heading: "Nagłówek {{level}}",
    quote: "Cytat",
    fontSizeDefault: "Domyślny",
    bold: "Pogrubienie",
    italic: "Kursywa",
    underline: "Podkreślenie",
    strikethrough: "Przekreślenie",
    code: "Kod",
    textColor: "Kolor tekstu",
    resetColor: "Kolor domyślny",
    highlight: "Wyróżnienie",
    removeHighlight: "Usuń wyróżnienie",
    backgroundColor: "Kolor tła",
    removeBackgroundColor: "Usuń kolor tła",
    table: {
      label: "Tabela",
      insert: "Wstaw tabelę",
      addRowBefore: "Dodaj wiersz powyżej",
      addRowAfter: "Dodaj wiersz poniżej",
      deleteRow: "Usuń wiersz",
      addColumnBefore: "Dodaj kolumnę z lewej",
      addColumnAfter: "Dodaj kolumnę z prawej",
      deleteColumn: "Usuń kolumnę",
      toggleHeaderRow: "Wiersz nagłówka",
      mergeOrSplit: "Scal / podziel komórki",
      delete: "Usuń tabelę",
    },
    link: "Link",
    linkText: "Tekst",
    linkUrl: "Adres",
    removeLink: "Usuń link",
    image: "Obraz",
    imageFromDisk: "Wgraj z komputera",
    imageError: "Nie udało się dodać tego obrazu.",
    imageUrl: "Adres obrazu",
    imageAlt: "Opis",
    bulletList: "Lista punktowana",
    orderedList: "Lista numerowana",
    listStyle: "Styl listy",
    listStyles: {
      disc: "Kropka",
      circle: "Okrąg",
      square: "Kwadrat",
      decimal: "1, 2, 3",
      lowerAlpha: "a, b, c",
      upperAlpha: "A, B, C",
      lowerRoman: "i, ii, iii",
      upperRoman: "I, II, III",
    },
    taskList: "Lista zadań",
    textAlign: "Wyrównanie",
    alignLeft: "Do lewej",
    alignCenter: "Wyśrodkuj",
    alignRight: "Do prawej",
    alignJustify: "Wyjustuj",
    lineHeight: "Interlinia",
    lineHeightDefault: "Domyślna",
    specialCharacter: "Znak specjalny",
    undo: "Cofnij",
    redo: "Ponów",
    divider: "Linia oddzielająca",
    clearFormatting: "Wyczyść formatowanie",
  },
};

export default pl;
